import { graphql } from 'react-relay';

/**
 * The two `Apis.Admin` experiment write actions. Kept in `relay/` (not a screen)
 * so the `graphql` tag stays confined to Babel-transformed data modules.
 */

/** Define an A/B split experiment over a flag: its key, the flag, and weighted arms. */
export const defineExperimentMutation = graphql`
    mutation experimentMutationsDefineMutation(
        $key: String!
        $flagKey: FeatureKey!
        $variants: [ExperimentVariantInput!]!
    ) {
        defineExperiment(key: $key, flagKey: $flagKey, variants: $variants) {
            key
            flagKey
            variants {
                name
                weight
            }
        }
    }
`;

/**
 * Eagerly enroll a fixed cohort of vaults into an experiment (deterministic,
 * sticky). Resolves to the number of vaults newly enrolled.
 */
export const enrollExperimentCohortMutation = graphql`
    mutation experimentMutationsEnrollMutation($experimentKey: String!, $vaultIds: [UUID!]!) {
        enrollExperimentCohort(experimentKey: $experimentKey, vaultIds: $vaultIds)
    }
`;
